import controller from './social-media.controller';

export default {
  controller,
  template: require('./social-media.html')
};



// WEBPACK FOOTER //
// src/app/components/social-media/social-media.component.ts